import { PARTNER_KEYS } from "../../utils/partner";
import FreeFitDefaultImg from "../../img/freefit_default.png";
import FreeFitLeumitDefaultImg from "../../img/default_freefit_leumit.png";
import FreeFitMaoflaamitDefaultImg from "../../img/default_freefit_maoflaamit.png";
import HistoryDefImg from "../../img/history_def_img.png";
import ClalitActiveLogoImg from "../../img/ff_and_active_logo_colored.png";
import MehudetWowLogoImg from "../../img/ff_and_wow_logo_colored.png";
import OvdimBariLogoImg from "../../img/ovdim_bari_logo_colored.png";
import LeumitLogoImg from "../../img/Leumit_Logo.png";
import MaoflaamitLogoImg from "../../img/maoflaamit_logo.png";
import PassCardClalitImg from "../../img/svg/multiple-entry-pass-card.svg";
import ClalitPlusCardImg from "../../img/svg/clalit+card.svg?inline";
import PassCardMaofImg from "../../img/svg/multiple-entry-pass-card-maof.png";
import PassCardOvdimBariImg from "../../img/svg/multiple-entry-pass-card-ovdimbari.svg";

// Per-partner imagery for V2 code — replaces JSX ternary chains.
// Only keys that differ from DEFAULTS need an entry per partner.
const DEFAULTS = {
  defaultClubImg: FreeFitDefaultImg,
  clubFallbackImg: FreeFitDefaultImg,
  passCardImg: PassCardOvdimBariImg,
  profilePassCardImg: null, // partners without one fall back to passCardImg in the consumer
  partnerLogoImg: null, // consumers must handle a missing mark
};

const BY_PARTNER = {
  [PARTNER_KEYS.CLALIT]: {
    clubFallbackImg: HistoryDefImg,
    passCardImg: ClalitPlusCardImg,
    // Profile keeps the pre-refresh card while home/pass-details/how-it-works
    // moved to the clalit+ artwork.
    profilePassCardImg: PassCardClalitImg,
    partnerLogoImg: ClalitActiveLogoImg,
  },
  [PARTNER_KEYS.MEHUDET]: {
    partnerLogoImg: MehudetWowLogoImg,
  },
  [PARTNER_KEYS.LEUMIT]: {
    clubFallbackImg: FreeFitLeumitDefaultImg,
    partnerLogoImg: LeumitLogoImg,
  },
  [PARTNER_KEYS.OVDIM_BARI]: {
    partnerLogoImg: OvdimBariLogoImg,
  },
  [PARTNER_KEYS.MAOFLAAMIT]: {
    clubFallbackImg: FreeFitMaoflaamitDefaultImg,
    passCardImg: PassCardMaofImg,
    partnerLogoImg: MaoflaamitLogoImg,
  },
};

export const getPartnerAsset = (partner, name) => BY_PARTNER[partner]?.[name] ?? DEFAULTS[name];
